// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.khReSwvvO8mbbRUEUV_1{margin-left:1px}`, "",{"version":3,"sources":["webpack://./src/components/MonacoSection/CustomMonacoEditor/custom-monaco-editor.module.scss"],"names":[],"mappings":"AAAA,sBACI,eAAA","sourcesContent":[".customMonacoEditor {\n    margin-left: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customMonacoEditor": `khReSwvvO8mbbRUEUV_1`
};
export default ___CSS_LOADER_EXPORT___;
